<!-- ========================= -->
<!-- HEADER / NAVBAR -->
<!-- ========================= -->
<app-navbar-style-two></app-navbar-style-two>

<!-- ========================= -->
<!-- MAIN HERO BANNER SLIDER -->
<!-- ========================= -->
<app-hometwo-banner></app-hometwo-banner>


<!-- ========================= -->
<!-- PRODUCT CATEGORY SECTION -->
<!-- ========================= -->
<div class="container toy-category-section">

    <div class="section-title text-center mb-5 fade-up">
        <span class="sub-title">Pick Your Favorite</span>
        <h2>Shop By Category</h2>
    </div>

    <div class="row justify-content-center">

        <!-- Skeleton loaders while categories are loading -->
        <ng-container *ngIf="loadingCategories">
            <div class="col-lg-2 col-md-3 col-6 mb-4" *ngFor="let s of [1,2,3,4,5,6]">
                <div class="category-card">
                    <div class="category-image skeleton-circle"></div>
                    <div class="skeleton-line mx-auto mt-3"></div>
                </div>
            </div>
        </ng-container>

        <!-- Actual category cards -->
        <div class="col-lg-2 col-md-3 col-6 mb-4 fade-up"
            *ngFor="let category of Categories; let i = index; trackBy: trackByCategory"
            [style.animation-delay.ms]="i * 80">

            <div class="category-card" (click)="goToCategory(category)">

                <div class="category-image">
                    <img [src]="category.image" [alt]="category.name" loading="lazy">
                </div>

                <h5>{{ category.name }}</h5>

            </div>

        </div>

    </div>

</div>



<!-- ========================= -->
<!-- PRODUCTS SECTION -->
<!-- ========================= -->
<section class="products-area pt-100 ">

    <div class="container">

        <div class="section-title text-center mb-4 fade-up">
            <span class="sub-title">Toy Box</span>
            <h2>Explore Products</h2>
        </div>

        <!-- Tabs -->
        <div class="product-tabs text-center mb-4 fade-up">

            <button class="explore_btn btn me-2 p-3"
                [ngClass]="selectedTab === 'popular' ? 'btn-primary' : 'btn-outline-primary'"
                (click)="setTab('popular')">
                Popular Products
            </button>

            <button class="explore_btn btn me-2 p-3"
                [ngClass]="selectedTab === 'new' ? 'btn-primary' : 'btn-outline-primary'" (click)="setTab('new')">
                New Arrivals
            </button>

            <button class="btn explore_btn p-3 d-none"
                [ngClass]="selectedTab === 'best' ? 'btn-primary' : 'btn-outline-primary'" (click)="setTab('best')">
                Best Sellers
            </button>

        </div>

        <!-- Tab Content with fade transition -->
        <div class="tab-content-wrapper" [attr.data-tab]="selectedTab">

            <div *ngIf="selectedTab === 'popular'" class="tab-pane-fade">
                <app-popular-products></app-popular-products>
            </div>

            <div *ngIf="selectedTab === 'new'" class="tab-pane-fade">
                <app-new-products></app-new-products>
            </div>

            <div *ngIf="selectedTab === 'best'" class="tab-pane-fade">
                <!-- <app-trending-products></app-trending-products> -->
            </div>

        </div>

    </div>

</section>


<!-- ========================= -->
<!-- OFFER BANNERS (STATIC) -->
<!-- ========================= -->
<section class="offer-banner-section pt-100 d-none ">

    <div class="container">

        <div class="row">

            <div class="col-lg-6 fade-up">
                <div class="offer-banner pink-banner">

                    <div class="content">
                        <span>Special Offer</span>
                        <h2>Flat 50% OFF</h2>
                        <p>On selected toy collections</p>
                        <a routerLink="/menu" class="default-btn">
                            Shop Now
                        </a>
                    </div>
                    <img class="w-50" src="../../../../assets/img/slider/offer1.png" alt="">

                </div>
            </div>

            <div class="col-lg-6 fade-up" style="animation-delay: 120ms;">
                <div class="offer-banner blue-banner">

                    <div class="content">
                        <span>Weekend Sale</span>
                        <h2>Buy 1 Get 1</h2>
                        <p>Exciting toys for kids</p>
                        <a routerLink="/menu" class="default-btn">
                            Explore
                        </a>
                    </div>
                    <img class="ml-auto w-50" src="../../../../assets/img/slider/offer2.png" alt="">
                </div>
            </div>

        </div>

    </div>

</section>


<!-- ========================= -->
<!-- OFFER BANNERS (DYNAMIC) — CAROUSEL -->
<!-- ========================= -->
<section class="offer-carousel-section" *ngIf="offerCards.length">

    <div class="container ps-5 pe-5">

        <div class="section-title text-center mb-0 fade-up">
            <span class="sub-title">🔥 Hot Deals</span>
            <h2>Exclusive Offers</h2>
        </div>

        <div class="offer-carousel-wrapper fade-up">

            <!-- Prev / Next arrows -->
            <button class="offer-nav offer-nav-prev" (click)="offerPrev()" aria-label="Previous offer">
                <i class="bx bx-chevron-left"></i>
            </button>

            <button class="offer-nav offer-nav-next" (click)="offerNext()" aria-label="Next offer">
                <i class="bx bx-chevron-right"></i>
            </button>

            <!-- Owl Carousel -->
            <owl-carousel-o [options]="offerCarouselOptions" #offerOwl>

                <ng-template carouselSlide *ngFor="let banner of offerCards; let i = index; trackBy: trackByOffer">

                    <div class="offer-slide">

                        <!-- Background image layer -->
                        <div class="offer-slide__bg"
                            [style.background-image]="'url(' + banner.image + ')'">
                        </div>

                        <!-- Dark gradient overlay -->
                        <div class="offer-slide__overlay"></div>

                        <!-- Content -->
                        <div class="offer-slide__content">

                            <span class="offer-slide__tag">
                                {{ banner.subtitle }}
                            </span>

                            <h2 class="offer-slide__title">
                                {{ banner.title }}
                            </h2>

                            <p class="offer-slide__desc">
                                {{ banner.content }}
                            </p>

                            <a [routerLink]="banner.button_link" class="offer-slide__btn">
                                {{ banner.button_text }}
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>

                        </div>

                    </div>

                </ng-template>

            </owl-carousel-o>

            <!-- Dot indicators (synced manually) -->
            <div class="offer-dots">
                <button
                    *ngFor="let banner of offerCards; let i = index"
                    class="offer-dot"
                    [class.active]="offerActiveIndex === i"
                    (click)="goToOfferSlide(i)"
                    [attr.aria-label]="'Go to slide ' + (i + 1)">
                </button>
            </div>

        </div>

    </div>

</section>


<!-- ========================= -->
<!-- BRANDS SECTION -->
<!-- ========================= -->
<section class="brands-section pt-100 ">

    <div class="container">

        <div class="section-title text-center fade-up mb-0">
            <span class="sub-title">Trusted Brands</span>
            <h2>Popular Toy Brands</h2>
        </div>

        <div class="brand-wrapper">

            <!-- Skeleton loaders -->
            <ng-container *ngIf="loadingBrands">
                <div *ngFor="let s of [1,2,3,4,5,6]">
                    <div class="brand-card skeleton"></div>
                </div>
            </ng-container>

            <div
                class="brands-slider"
                *ngIf="brands.length">

                <div class="brands-track">

                    <div
                        class="brand-card"
                        *ngFor="let brand of brands">

                        <img
                            class="brand-logo"
                            [src]="brand.brand_image"
                            [alt]="brand.brand_name">

                    </div>

                    <!-- Duplicate for seamless loop -->
                    <div
                        class="brand-card"
                        *ngFor="let brand of brands">

                        <img
                            class="brand-logo"
                            [src]="brand.brand_image"
                            [alt]="brand.brand_name">

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- ========================= -->
<!-- TESTIMONIALS -->
<!-- ========================= -->
<section class="testimonial-section pt-100">

    <div class="container">

        <div class="section-title text-center fade-up mb-0">
            <span class="sub-title mb-0">Happy Customers</span>
            <!-- <h2>What Parents Say</h2> -->
        </div>

        <app-testimonials></app-testimonials>

    </div>

</section>

<!-- ========================= -->
<!-- NEWSLETTER SUBSCRIPTION -->
<!-- ========================= -->
<section class="newsletter-section">

    <div class="container">

        <div class="newsletter-box fade-up">

            <div class="content">
                <h2>Subscribe To Our Newsletter</h2>

                <p>
                    Get updates about new toys, exclusive offers,
                    and exciting discounts.
                </p>
            </div>

            <form class="newsletter-form">

                <input type="email" name="newsletterEmail" [(ngModel)]="newsletterEmail"
                    placeholder="Enter your email" class="form-control" required>

                <button type="submit" class="default-btn" (click)="subscribeNewsletter()">
                    Subscribe
                </button>

            </form>

        </div>

    </div>

</section>

<!-- ========================= -->
<!-- FLOATING SOCIAL BUTTONS -->
<!-- ========================= -->
<div class="floating-buttons">

    <!-- WhatsApp -->
    <a href="https://wa.me/97444517369" class="floating-btn whatsapp-btn" target="_blank">
        <i class='bx bxl-whatsapp'></i>
    </a>

    <!-- Call -->
    <a href="tel:+97444517369" class="floating-btn mobile-btn">
        <i class='bx bx-phone-call'></i>
    </a>

    <!-- Instagram -->
    <a href="https://instagram.com/yourusername" class="floating-btn instagram-btn" target="_blank">
        <i class='bx bxl-instagram'></i>
    </a>

    <!-- Facebook -->
    <a href="https://facebook.com/yourpagename" class="floating-btn facebook-btn" target="_blank">
        <i class='bx bxl-facebook'></i>
    </a>

</div>

<!-- ========================= -->
<!-- WELCOME MODAL -->
<!-- ========================= -->
<div class="welcome-backdrop" *ngIf="showWelcomeModal" [class.closing]="isClosing">

    <div class="welcome-modal" [class.closing]="isClosing">

        <h1>🎉 Welcome to Sangeetha Toys</h1>

        <p class="text-white">
            Discover magical toys, exciting games,
            and endless smiles for your little ones ✨
        </p>

        <button class="enter-btn" (click)="closeWelcomeModal()">
            Start Exploring
        </button>

    </div>

</div>


<!-- ========================= -->
<!-- OFFER POPUP -->
<!-- ========================= -->
<div class="offer-popup-backdrop" *ngIf="showOfferPopup && popupBanner" [class.closing]="isClosingPopup">

    <div class="offer-popup" [class.closing]="isClosingPopup"
        [style.background-image]="'url(' + popupBanner.image + ')'" [style.background-size]="'cover'"
        [style.background-position]="'center'">

        <button class="close-btn" (click)="closeOfferPopup()">
            ×
        </button>

        <h2>{{ popupBanner.title }}</h2>

        <p>{{ popupBanner.subtitle }}</p>

        <a [routerLink]="popupBanner.button_link" class="default-btn align-self-center w-50">
            {{ popupBanner.button_text }}
        </a>

    </div>

</div>


<!-- ========================= -->
<!-- FOOTER -->
<!-- ========================= -->
<!-- <app-footer></app-footer> -->